import { Image } from "@components/anti/Image"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, convertJson, imgUrl } from "src/mixins"

export function MtixTopup({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  const { topup, topupPartners, paymentPartners } = data
  return (
    <section className="py-5 sc-mtix-topup" ref={trigger}>
      <div className="cinema-gradient" />

      <div className="container">
        <div className="w-md-850px mb-5">
          <h2 className={anim(1)}>{topup[`title_${locale}`]}</h2>
          <div className={`text ${anim(2)}`}>
            {convertHtmlToReact(topup[`description_${locale}`])}
          </div>
        </div>
        {/* <div className="partners-wrapper">
          <p className="text-uppercase text-muted">
            {topupPartners[`title_${locale}`]}
          </p>
          <div className="row partners-list">
            {convertJson(topupPartners?.partners).map((item, i) => (
              <div className="col-6 col-md-3 col-lg-2 mb-3" key={i}>
                <div className="partners-item">
                  <Image
                    src={imgUrl(item?.logo)}
                    alt="partners"
                    width="144"
                    height="36"
                  />
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <div className="partners-wrapper">
          <p className={`text-uppercase text-muted ${anim(3, "fadeInUp8")}`}>
            {paymentPartners[`title_${locale}`]}
          </p>
          <div className="row partners-list">
            {convertJson(paymentPartners?.partners)?.map((item, i) => (
              <div className="col-6 col-md-2 mb-3" key={i}>
                <div className={`partners-item ${anim(i + 4)}`}>
                  <Image
                    src={imgUrl(item?.logo)}
                    alt="partners"
                    width="144"
                    height="36"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
